package eu.codlab.compose.utils

import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform

internal val compatiblePlatforms = listOf(
    Platform.IOS,
    Platform.JVM,
    Platform.ANDROID
)

internal fun isCompatibleForSpacers() = compatiblePlatforms.contains(currentPlatform)
